import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const selector = `.${manifest.componentJsClass}`;
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const { PostListing } = await import('./post-listing');

	[...elements].forEach((element) => {
		const postListing = new PostListing({
			element,
			postsContainerSelector: `${selector}-posts`,
			loadMoreButtonSelector: `${selector}-load-more-button`,
			loaderSelector: `${selector}-loader`,
		});

		postListing.init();
	});
});
